import { hasOwnProperty } from "@glideapps/ts-necessities";

import { globalSettingsCollectionName } from "./database-strings";
import { Database } from "./Database";

const termsOfServiceDocumentName = "terms-of-service";

export type TermsOfService = Readonly<{
    currentVersion: number;
    termsLink: string;
    privacyLink: string;
}>;

export function isTermsOfService(x: unknown): x is TermsOfService {
    return (
        typeof x === "object" &&
        hasOwnProperty(x, "currentVersion") &&
        hasOwnProperty(x, "termsLink") &&
        hasOwnProperty(x, "privacyLink")
    );
}

export async function getCurrentTermsOfService(db: Database): Promise<TermsOfService | undefined> {
    const untyped = await db.getDocument(globalSettingsCollectionName, termsOfServiceDocumentName);
    return isTermsOfService(untyped) ? untyped : undefined;
}
